import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate ,useLocation} from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Navbar from '../../Components/Navbar/Navbar';
import api from '../../Common/Api/UserApi';
import { saveAddress } from '../../features/User/UserSlice';
import './Checkout.css'

 
const Checkout = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.BookWormUser.userInfo);
    // console.log(user)
    const loc = useLocation();
    const keypress = useRef();
    const {books,totalCost} = loc.state;    // boooks to buy
    console.log("state from cart ",books);

    const [credentials,setCredentials] = useState({name:'',email:'',contact:''});
    const [address,setAddress] = useState({streetAddress:'',city:'',state:'',pincode:''});


    const {BookWormUser} = useSelector((state)=>state);


    const navigate = useNavigate();

    const onchange = (e)=>{
        setCredentials({...credentials,[e.target.name]:e.target.value});
    }
    const onAddresschange = (e)=>{
        setAddress({...address,[e.target.name]:e.target.value});
    }
    useEffect(() => {
    const keyDownHandler = event => {
      console.log('User pressed: ', event.key);

      if (event.key === 'Enter') {
        event.preventDefault();
        keypress.current.click();
    //    handleSearch(event)
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  });

    const handleCheckout  = async(e)=>{
        console.log("hanlecheckout")

        if(!credentials.name || !credentials.email || !credentials.contact){
            alert('Please Fill All The User Details Correctly');
            return;
        }
        
        if(!address.city || !address.pincode || !address.state || !address.streetAddress){
            alert('Please Fill the Shipping Details Correctly');
            return;

        }

        e.preventDefault();
        const {data:{key}} = await api.get('/getKey');
        const {data:{order}} = await api.post('/user/checkout', {
            amount:totalCost
        });
        dispatch(saveAddress(address));
        const verification_body={ razorpay_payment_id:'',razorpay_order_id:'',razorpay_signature:'',_id:'',name:credentials.name,email:credentials.email,contact:credentials.contact,streetAddress:address.streetAddress,city:address.city,state:address.state,pincode:address.pincode,books:books};
        const options = {
            key, // the razorpay Key ID generated from the Dashboard
            amount: order.amount, 
            currency: "INR",
            name: "BookWorm",
            description: "Test Transaction",
            image: "https://example.com/your_logo", // the image url which will be displayed on the payment page
            order_id: order.id, 
            // callback_url: `http://localhost:5000/user/paymentVerification`,
            handler: async function (response){
                verification_body.razorpay_payment_id = response.razorpay_payment_id;
                verification_body.razorpay_order_id =  response.razorpay_order_id;
                verification_body.razorpay_signature = response.razorpay_signature;
                verification_body._id = user._id;
                const data = await api.post('/user/paymentVerification',verification_body);
                console.log(data)
                if(data){
                    navigate('/paymentSuccess');
                }
                else{
                    navigate('/paymentFailed');
                }
            },
            prefill: {
                "name": user.name, // login user name
                "email": user.email, // login user email
                "contact": user.contact // login user contact
            },
            notes: {
                "address": "Razorpay Corporate Office"
            },
            theme: {
                "color": "#ff5757"
            }
        };
        console.log(window)
        const razor = new window.Razorpay(options);
        
        razor.open();
        razor.on('payment.failed', function (response){
            alert(response.error.code);
        });

    }

    const [total,setTotal] = useState(0);

    const calculateTotal=()=>{
        var cost = 0;

        setTotal(cost);
    }
    

    useEffect(() => {
        BookWormUser.userInfo.shippingAddress?setAddress(BookWormUser.userInfo.shippingAddress):console.log("");
        setCredentials({name:BookWormUser.userInfo.name,email:BookWormUser.userInfo.email,contact:BookWormUser.userInfo.contact})
        calculateTotal();
    }, [])
    

    return (
        <>
            <Navbar colorRight="#5f2c3e" colorLeft="#5f2c3e" />

            <div className='checkout-page'>
                <div className='checkout-container'>

                    <div className='shipping-details'>

                        <h3>Checkout</h3>

                        <div>
                            <h4>Shipping Details</h4>

                            <form>
                                <div className='form-components c-out'>
                                    <label>Name</label>
                                    <input type='text' className='form-control' placeHolder='eg : John' name='name' onChange={onchange} value={credentials.name} required></input>
                                </div>

                                <div className='form-components c-out'>
                                    <label>Email</label>
                                    <input type='email' className='form-control' placeHolder='eg : abc@gmail.com' name='email' onChange={onchange} value={credentials.email} required></input>
                                </div>

                                <div className='form-components c-out'>
                                    <label>Mobile Number</label>
                                    <input class="form-control" type="text" placeholder="+91 - " name='contact' onChange={onchange} value={credentials.contact} required></input>
                                </div>
                                <hr />
                              
                                <h4>Shipping Address</h4>

                                <div className='form-components c-out'>
                                    <label>Street Address</label>
                                    <input class="form-control" type="text" placeholder="Apartment / Locality" name='streetAddress' onChange={onAddresschange} value={address.streetAddress} required></input>
                                </div>
                                <div className='form-components c-out'>
                                    <label>City</label>
                                    <input class="form-control" type="text" placeholder="" name='city' onChange={onAddresschange} value={address.city} required></input>
                                </div>
                                <div className='form-components c-out'>
                                    <label>State</label>
                                    <input class="form-control" type="text" placeholder="" name='state' onChange={onAddresschange} value={address.state} required></input>
                                </div>
                                <div className='form-components c-out'>
                                    <label>Area Pincode</label>
                                    <input class="form-control" type="text" placeholder="" name='pincode' onChange={onAddresschange} value={address.pincode} required></input>
                                </div>

                            </form>

                            
                        </div>
                        

                    </div>

                    <div className='order-summary'>

                        <h3>Order Summary</h3>

                        {
                            books.map((element)=>{
                                return (
                                    <div className='order-item'>
                                        <div className='order-image-container'>
                                            <img src={element.img} alt="" className='order-image'/>
                                        </div>
                                        <div className='order-item-detail'>

                                            <div><b>{element.title}</b></div>
                                            <div><b>Price - {element.price}</b></div>

                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                       
                        <hr />

                        <div>
                            <div className='item-price label'>
                                <div className='item'>Item(s)</div>
                                <div className='price'>Price</div>
                            </div>
                            {
                                books.map((element)=>{
                                    return (
                                    <div className='item-price'>
                                        <div className='item'>{element.title}</div>
                                        <div className='price'>{element.price}</div>
                                    </div>
                                    )
                                })
                            }
                            <hr />
                            <div className='item-price label'>
                                <div className='item'><b>Total : </b></div>
                                <div className='price'><b>{totalCost} Rs.</b></div>
                            </div>
                           
                            <div className='order-btn-box'>
                                <button className='order-button main' ref={keypress} onClick={handleCheckout}>Pay Now!</button>
                                <button className='order-button' disabled style={{backgroundColor:"rgb(183, 183, 183)"}}>CashOnDelivery</button>
                            </div>

                            
                        </div>

                        

                    </div>

                </div>

            </div>
        
  
            <Footer/>
        </>
  )
}

export default Checkout